<template>
    <div class="text-center">
		<v-dialog
			v-model="show"
			width="600"
			@input="(v) => v || closeModal()"
			content-class="add-question-modal overflow-x-hidden"
            @click:outside="closeModal"
		>
            <v-card class="add-question-modal__card">
				<div class="add-question-modal__title">
					Create Question
				</div>
                <div class="add-question-modal__label-wrapper">
                    <span class="add-question-modal__label">
                        TEXT
                    </span>
                </div>
                <SessionQuestionForm 
                    :qaIsAutocomplete="qaIsAutocomplete" 
                    :isQuestionsPage="isQuestionsPage"
                    v-on:closeModal="closeModal"
                />
                <v-btn 
                    icon 
                    class="add-question-modal__button-close"
                    style="background-color: transparent !important;"
                    @click="closeModal"
                >
                    <v-icon color="#0055A3">mdi-close</v-icon>
                </v-btn>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SessionQuestionForm from '@/components/Forms/SessionQuestionForm.vue';
export default {
    components: {
        SessionQuestionForm
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        qaIsAutocomplete: {
            type: Boolean,
            default: false
        },
        isQuestionsPage: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        }
    }
}
</script>

<style lang="scss">
.add-question-modal {
	border-radius: 10px;
    background-color: #fff;
    font-family: Montserrat, sans-serif;

    &__card {
        position: relative;
        padding: 30px;
    }

    &__title {
		color: var(--accent-color);
		font-size: 24px;
		font-weight: 700;
        line-height: 29.26px;
        margin-bottom: 20px;
	}

	&__label {
        font-size: 14px;
        font-weight: 700;
        line-height: 17.07px;
        color: var(--button-main-background-color);
        padding-bottom: 4.5px;
        border-bottom: 2px solid var(--button-main-background-color);

        &-wrapper {
            border-bottom: 1px solid #E2E2E2;
            padding-bottom: 3px;
            margin-bottom: 30px;
        }
	}

    &__button-close {
        position: absolute;
        top: 20px;
		right: 20px;
    }
}
</style>